module.exports = __webpack_public_path__ + "static/media/bebe3.e24873d0.jpg";